import { memo } from 'react';

import { MemberAdd } from '@air/next-icons';
import { Button } from '@air/primitive-button';

import { useShowSideNavTeamInviteNudge } from '~/hooks/useShowSideNavTeamInviteNudge';

export const WorkspaceSidebarTeamInviteNudge = memo(() => {
  const { dismissSideNavTeamInviteNudge, isSideNavTeamInviteNudgeVisible, openSideNavTeamInviteNudgeModal } =
    useShowSideNavTeamInviteNudge();

  if (!isSideNavTeamInviteNudgeVisible) {
    return null;
  }

  return (
    <div className="mt-auto pt-3">
      <div
        className="mb-3 rounded-6 border border-blue-3 bg-blue-1 p-4"
        data-testid="WORKSPACE_SIDEBAR_TEAM_INVITE_NUDGE"
      >
        <p className="font-semibold text-14 text-gray-12">Gather your team in Air</p>
        <p className="mt-1 text-14 text-gray-12">All plans have unlimited seats to make collaboration seamless.</p>
        <div className="mt-3 flex items-center gap-2">
          <Button
            appearance="filled"
            className="max-w-full overflow-hidden"
            color="blue"
            onClick={openSideNavTeamInviteNudgeModal}
            prefix={<MemberAdd className="size-4" />}
            size="small"
            type="button"
          >
            <span className="truncate">Invite your team</span>
          </Button>

          <Button appearance="ghost" color="grey" onClick={dismissSideNavTeamInviteNudge} size="small" type="button">
            Not now
          </Button>
        </div>
      </div>
    </div>
  );
});

WorkspaceSidebarTeamInviteNudge.displayName = 'WorkspaceSidebarTeamInviteNudge';
